import React, { useState, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
// import queryString from 'query-string';
// import numeral from 'numeral';
import moment from 'moment';

// import { useTheme } from '@material-ui/core/styles';

// import { makeRowColumn, getHeadObj, dataConverter } from 'lib/commonLib';
// import { setPortal } from 'modules/portal';
// import { userOnLogin } from 'lib/api/user';
// import {
//   advertiserStatistics,
//   advertiserStatisticsDetail,
// } from 'lib/api/report';

// import MbTooltip from 'components/atoms/MbTooltip';
// import MbButton from 'components/atoms/MbButton';
// import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
// import NewCheckbox from 'components/molecules/NewCheckbox';
import FilterCollection from 'components/organisms/FilterCollection';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
// import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';

// import StatisticsGraph from './StatisticsGraph';

const Kpi = ({ location }) => {
  const { t } = useTranslation();
  // const theme = useTheme();
  // const dispatch = useDispatch();
  // const { portal } = useSelector(({ portal }) => ({
  //   portal: portal,
  // }));

  const initParams = {
    sort: 'desc',
    order: 'ADVRTS_AMT',
    sDate: moment().format('YYYYMM01'),
    eDate: moment().format('YYYYMMDD'),
    diffSDate: moment().format('YYYYMM01'),
    diffEDate: moment().format('YYYYMM01'),
    option2: 'all',
    // option3: 'all',
    // kpi: 'all',
  };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  // 매출금액  단가  세션ROAS  직접ROAS  총ROAS  전환단가  전환건수
  // const [kpiList, setKpiList] = useState([
  const [kpiList] = useState([
    { label: '노출수', value: '01' },
    { label: '클릭수', value: '02' },
    { label: '소진금액', value: '03' },
    { label: '매출금액', value: '04' },
    { label: '단가', value: '05' },
    { label: '세션ROAS', value: '06' },
    { label: '직접ROAS', value: '07' },
    { label: '총ROAS', value: '08' },
    { label: '전환단가', value: '09' },
    { label: '전환건수', value: '10' },
  ]);

  const optionList = {
    option1: [
      // { label: '전체', value: 'all' },
      { label: '300만원 이상', value: '01' },
      { label: '500만원 이상', value: '02' },
    ],
    option2: [
      { label: '미선택', value: 'all' },
      { label: '전체', value: '01' },
      { label: '보장', value: '02' },
    ],
    option3: [
      { label: '기준일 미달성', value: '01' },
      { label: '비교일 미달성', value: '02' },
    ],
  };

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  // const handlePortalUrl = (url) => {
  //   let newPortal = portal.portal;
  //   let popIndex = newPortal.length;
  //   newPortal[popIndex] = { url: url, cnt: popIndex };
  //   dispatch(setPortal(newPortal));
  // };

  // header 및 body 컬럼 커스텀
  // const customized = {};

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  // /**
  //  * 로그인처리
  //  */
  // const handleOnLogin = (ADVER_ID) => {
  //   userOnLogin(ADVER_ID, 'manage')
  //     .then((response) => {
  //       const { data, success } = response.data;
  //       if (success) {
  //         handlePortalUrl(data.url);
  //       } else {
  //         alert('로그인에 실패했습니다. 관리자에게 문의하세요.');
  //       }
  //     })
  //     .catch((error) => {
  //       console.log('error', error);
  //     });
  // };
  //
  // const handleChangeValue = (e) => {
  //   const { name } = e.target;
  //   const newParams = {
  //     ...params,
  //     [name]: params[name] === '01' ? '02' : '01',
  //   };
  //   getParam(newParams);
  // };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={params}
          getParam={getParam}
          useDiffDate
          usePltfomTpCodeFilter={false}
          useDisplayFilter={false}
          useExternalFilter={false}
          useManagerFilter={true}
        />
        <FilterCollection
          label={t('KPI기준')}
          name="kpi"
          params={params}
          value={params.kpi}
          type="checkbox"
          list={kpiList}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
          useSubmit
          submitTitle={t('저장')}
        />
        <FilterCollection
          label={t('기준일 소진범위')}
          name="option1"
          params={params}
          value={params.option1}
          type="checkbox"
          list={optionList.option1}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
          useSubmit
          submitTitle={t('저장')}
        />
        <FilterCollection
          label={t('보장여부')}
          name="option2"
          params={params}
          value={params.option2}
          type="select"
          list={optionList.option2}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
        />
        <FilterCollection
          label={t('미달성여부')}
          name="option3"
          params={params}
          value={params.option3}
          type="checkbox"
          list={optionList.option3}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
          useSubmit
          submitTitle={t('저장')}
        />
        {/*<NewCheckbox*/}
        {/*  label={t('내 광고주보기')}*/}
        {/*  name="myFlag"*/}
        {/*  onChange={handleChangeValue}*/}
        {/*  checked={params.myFlag === '01'}*/}
        {/*/>*/}
      </NewFilterWrap>

      {/*{isPop === false && (*/}
      {/*  <StatisticsGraph handleGetTotalCount={handleGetTotalCount} />*/}
      {/*)}*/}
      {/*<NewTableContainer*/}
      {/*  params={params}*/}
      {/*  getParam={getParam}*/}
      {/*  dataReqPromise={advertiserStatistics}*/}
      {/*  // customized={customized}*/}
      {/*  useSearch={false}*/}
      {/*/>*/}
    </>
  );
};

export default withRouter(Kpi);
